import { apiClient } from '../apiClient';
import type { ApiResponse } from '../http/types';
import type {
  CustomerListItem,
  ApiErrorResponse,
  CustomerOverview,
  CustomerSiteSummary,
  CreateCustomerRequest,
  UpdateCustomerRequest,
} from './customer.types';

const base = '/api/Customer';

export function listCustomers(): Promise<ApiResponse<CustomerListItem[]>> {
  return apiClient.get<CustomerListItem[]>(`${base}/all`);
}

// GET may return ApiErrorResponse shape for not-found or error; keep ApiResponse generic to union if needed at call site
export function getCustomer(id: string | number): Promise<ApiResponse<CustomerListItem | ApiErrorResponse>> {
  return apiClient.get<CustomerListItem | ApiErrorResponse>(`${base}/${encodeURIComponent(id)}`);
}

export function createCustomer(payload: CreateCustomerRequest): Promise<ApiResponse<CustomerListItem>> {
  return apiClient.post<CustomerListItem>(`${base}`, payload);
}

export function updateCustomer(id: string | number, payload: UpdateCustomerRequest): Promise<ApiResponse<CustomerListItem>> {
  return apiClient.put<CustomerListItem>(`${base}/${encodeURIComponent(id)}`, payload);
}

export function deleteCustomer(id: string | number): Promise<ApiResponse<boolean>> {
  return apiClient.delete<boolean>(`${base}/${encodeURIComponent(id)}`);
}

export function restoreCustomer(id: string | number): Promise<ApiResponse<CustomerListItem>> {
  return apiClient.patch<CustomerListItem>(`${base}/${encodeURIComponent(id)}/restore`, {});
}

export function getCustomerOverview(): Promise<ApiResponse<CustomerOverview>> {
  return apiClient.get<CustomerOverview>(`${base}/overview`);
}

export function getCustomerSites(customerId: string | number): Promise<ApiResponse<CustomerSiteSummary[]>> {
  return apiClient.get<CustomerSiteSummary[]>(`${base}/customers/${encodeURIComponent(customerId)}/sites`);
}
